import React from 'react';
import PropTypes from 'prop-types';

import ReactPaginate from 'react-paginate';

import './Pagination.css';

const Pagination = ({
  pageCount,
  marginPagesDisplayed,
  pageRangeDisplayed,
  onPageChange,
  containerClassName,
}) => (
  <ReactPaginate
    containerClassName={`pagination__component${containerClassName ?
      ` ${containerClassName}` : ''}`}
    activeClassName="active"
    previousLabel="<"
    nextLabel=">"
    pageCount={pageCount}
    marginPagesDisplayed={marginPagesDisplayed}
    pageRangeDisplayed={pageRangeDisplayed}
    onPageChange={onPageChange}
  />
);

Pagination.propTypes = {
  pageCount: PropTypes.number.isRequired,
  marginPagesDisplayed: PropTypes.number,
  pageRangeDisplayed: PropTypes.number,
  onPageChange: PropTypes.func.isRequired,
  forcePage: PropTypes.number,
  containerClassName: PropTypes.string,
};

Pagination.defaultProps = {
  marginPagesDisplayed: null,
  pageRangeDisplayed: null,
  forcePage: null,
  containerClassName: null,
};

export default Pagination;
